import React from 'react';
import { NavLink } from 'react-router-dom';

import './Home.css';

const FeaturedLink = ({ route, text, description, icon }) => (
    <NavLink to={route} className="featured-link-card">
        <div className="featured-link-icon">
            <i className={`bi bi-${icon}`}></i>
        </div>
        <div className="featured-link-body">
            <div className="featured-link-title">{text}</div>
            <div className="featured-link-description">{description}</div>
        </div>
        <i className="bi bi-chevron-right featured-link-arrow"></i>
    </NavLink>
);

const Home = ({ isLoggedIn }) => {
    const featuredLinks = [
        isLoggedIn && {
            route: '/myTeam',
            text: 'My Team',
            description: 'Manage your roster & contracts',
            icon: 'people-fill',
        },
        {
            route: '/draftLobby',
            text: 'Draft Lobby',
            description: 'Live draft room & pick tracking',
            icon: 'clipboard-data',
        },
        {
            route: '/myTeam/draftPicks',
            text: 'Future Draft Picks',
            description: 'Upcoming picks by year & round',
            icon: 'calendar3',
        },
        {
            route: '/history',
            text: 'League History',
            description: 'Champions, records & past seasons',
            icon: 'clock-history',
        },
    ].filter(Boolean);

    return (
        <div id='homeContainer' className="d-flex flex-column align-items-center">
            <div className="hero-section">
                <h1 className="hero-title">Underwhelming Gents</h1>
                <p className="hero-subtitle">Fantasy Football League</p>
                <p className="hero-established">Est. 2017</p>
            </div>
            <div className="featured-links-grid">
                {featuredLinks.map((link) => (
                    <FeaturedLink key={link.route} {...link} />
                ))}
            </div>
        </div>
    );
}

export default Home;
